/**
 * Lo que lee el agente mientras Gustavo trabaja (30/10/2026).
 *
 * La mediana de un turno son 23 s (p95 45 s) y hasta ahora la espera eran tres puntos y
 * un chip con el nombre de la tool. Con una frase en castellano se entiende QUÉ está
 * haciendo, y pasado el umbral se avisa que sigue en eso: la sensación de "se colgó"
 * aparece antes que la respuesta.
 */

/** A partir de acá se avisa que está tardando más de lo normal. */
export const UMBRAL_LENTO_MS = 15_000;

const POR_TOOL: Record<string, string> = {
  search_properties:            'Buscando propiedades…',
  search_customers:             'Buscando clientes…',
  get_property:                 'Abriendo la ficha de la propiedad…',
  get_customer:                 'Abriendo la ficha del cliente…',
  summarize_customer:           'Resumiendo al cliente…',
  search_in_help:               'Consultando la Ayuda…',
  buscar_en_la_charla:          'Buscando en nuestra charla…',
  my_today_briefing:            'Armando tu día…',
  get_home_today:               'Armando tu día…',
  my_performance_metrics:       'Calculando tus métricas…',
  inactive_customers_alert:     'Revisando qué clientes se enfriaron…',
  match_customer_to_properties: 'Cruzando el cliente con las propiedades…',
  match_property_to_customers:  'Cruzando la propiedad con tus clientes…',
  create_event:                 'Agendando…',
  update_event:                 'Moviendo el evento…',
  schedule_showing_with_customer: 'Agendando la visita…',
  create_reminder:              'Creando el recordatorio…',
  send_agent_message:           'Enviando el mensaje…',
  send_group_message:           'Enviando al grupo…',
  draft_customer_email:         'Redactando el email…',
  create_property:              'Creando la propiedad…',
  add_property_images:          'Subiendo las fotos…',
  generate_owner_portal_link:   'Generando el link del propietario…',
  start_valuation:              'Preparando la tasación…',
  check_meli_listing_status:    'Consultando MercadoLibre…',
};

/** Texto de progreso para la tool en curso. Sin tool, Gustavo está pensando la respuesta. */
export function textoDeEspera(tool?: string): string {
  if (!tool) return 'Pensando…';
  const exacto = POR_TOOL[tool];
  if (exacto) return exacto;
  if (/^(search|list|get|find|my_)/.test(tool)) return 'Consultando el CRM…';
  if (/^(create|update|delete|complete|cancel|reserve|transfer|publish|add|remove|advance|close|enviar|registrar)/.test(tool)) return 'Guardando en el CRM…';
  return 'Trabajando en eso…';
}

/** El aviso de demora: solo pasado el umbral. */
export function avisoDeDemora(transcurridoMs: number): string | null {
  return transcurridoMs >= UMBRAL_LENTO_MS ? 'Está tardando más de lo normal, sigo en eso.' : null;
}
